// src/main.ts
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { purgeLegacySensitiveStorage } from './app/core/storage/safe-store-persistence';

purgeLegacySensitiveStorage();

bootstrapApplication(AppComponent, appConfig).catch((err: unknown) =>
  console.error('Application bootstrap failed', err)
);
